import React from "react";
import { motion } from "motion/react";
import { useRevealInitial } from "../../lib/motion";

const SandPandD = ({ title, p1, p2, p3, imgsrc, img2src, link, bulletList, numList, reverse, floatImgs }) => {
  const imgClass = `max-h-72 w-auto rounded-lg border border-ink-800 object-contain ${floatImgs ? "shadow-[0_12px_30px_-10px_rgba(0,0,0,0.6)]" : ""}`;

  return (
    <motion.section
      id={title}
      className="mx-auto max-w-3xl border-t border-ink-800 px-6 py-12"
      initial={useRevealInitial({ opacity: 0, y: 16 })}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ type: "spring", stiffness: 300, damping: 30 }}
    >
      <h2 className="mb-6 text-2xl font-semibold text-mist-100">{title}</h2>

      <div className={`flex flex-col items-center gap-8 md:items-start ${reverse ? "md:flex-row-reverse" : "md:flex-row"}`}>
        {(imgsrc || img2src) && (
          <div className="flex w-full flex-wrap justify-center gap-4 md:w-2/5">
            {imgsrc && <img src={imgsrc} className={imgClass} alt={title} />}
            {img2src && <img src={img2src} className={imgClass} alt={title} />}
          </div>
        )}

        <div className="w-full md:flex-1">
          {p1 && <p className="mb-4 leading-relaxed text-mist-500">{p1}</p>}
          {link && (
            <p className="mb-4">
              <a href={link[1]} target="_blank" rel="noreferrer" className="hover-underline font-mono text-sm text-signal-400">
                {link[0]}
              </a>
            </p>
          )}
          {bulletList && (
            <ul className="mb-4 list-disc space-y-1 pl-5 marker:text-signal-400">
              {bulletList.map((item, i) => (
                <li key={i} className="leading-relaxed text-mist-500">{item}</li>
              ))}
            </ul>
          )}
          {p2 && <p className="mb-4 leading-relaxed text-mist-500">{p2}</p>}
          {numList && (
            <div className="mb-4 space-y-2 font-mono text-sm">
              {Object.entries(numList).map(([label, item]) => (
                <div key={label} className="flex gap-2">
                  <span className="font-semibold text-signal-400">{label}:</span>
                  <span className="text-mist-500">{item}</span>
                </div>
              ))}
            </div>
          )}
          {p3 && <p className="leading-relaxed text-mist-500">{p3}</p>}
        </div>
      </div>
    </motion.section>
  );
};

export default SandPandD;
